import React, {useState, useEffect, useRef} from 'react'
import {IconButton, Popover, Checkbox, Typography, TextField, Grid} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import InputAdornment from '@material-ui/core/InputAdornment'
import './FilterFieldList.scss'
export default function FilterFieldsList({options, handleClickOption, value, values, open}) {
  const [filteredOptions, setFilteredOptions] = useState([])
  const [isSearching, setSearching] = useState(false)
  const [search, setSearch] = useState('')
  const [realSearch, setRealSearch] = useState('')
  const refSearch = useRef(null)
  useEffect(() => {
    let _filteredOptions = []
    let filterTypes = [
      'EntityListField',
      'MultipleEntityListField',
      'ApUserField',
      'StatusField',
      'ListField',
      'MultipleListField',
      'YesNoField',
    ]
    options.map(o => {
      if (
        filterTypes.includes(o.field_type) &&
        o.field_name.toLowerCase().match(realSearch.toLowerCase())
      ) {
        _filteredOptions.push(o)
      }
      return true
    })

    setFilteredOptions(_filteredOptions)
  }, [options, realSearch, value, values, open])

  const handleSearch = e => {
    if ('Enter' === e.key) {
      setRealSearch(search)
    } else {
      setSearching(true)
    }
  }

  let textInput = useRef()

  const handleSearchText = e => {
    e.preventDefault()
    setSearch(e.target.value)
    if (e.target.value === '') {
      setRealSearch('')
    }
  }

  const isSelected = id => {
    if (value && (value?.field_id === id || value?.id === id)) {
      return true
    }
    return false
  }

  const onCloseSearch = () => {
    refSearch.current.focus()
    setSearch('')
    setRealSearch('')
    setSearching(true)
  }

  return (
    <div
      className="c-res-mod ap-list ap-scrollbar"
      style={{maxHeight: 400, padding: '17px', width: '200px'}}
    >
      <Grid container style={{position: 'relative'}} xs={12}>
        {isSearching ? (
          <Grid item xs={10} className="search-option-body-gantt-filter">
            <TextField
              ref={textInput}
              onBlur={() => {
                isSearching === true && search === '' ? setSearching(false) : setSearching(true)
              }}
              id="standard-basic"
              type="text"
              className="c-res-mod ap-list ap-scrollbar"
              autoFocus
              value={search}
              onChange={handleSearchText}
              onKeyDown={e => handleSearch(e)}
              inputRef={refSearch}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <div isDisabled={true}>
                      <CloseIcon style={{cursor: 'pointer'}} onClick={onCloseSearch} /> |{' '}
                    </div>
                    <IconButton
                      type="submit"
                      className="ap-icon-button"
                      underline={false}
                      aria-label="search"
                      style={{padding: 0}}
                      onClick={() => {
                        if (isSearching === true && search.length !== 0) {
                          setRealSearch(search)
                        } else {
                          setSearching(true)
                        }
                      }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        ) : (
          <Grid xs={10} style={{position: 'absolute', right: '0px', top: '-1px'}}>
            <Typography style={{position: 'absolute', right: '112px'}}>Fields</Typography>
            <IconButton
              type="submit"
              className="ap-icon-button"
              underline={false}
              aria-label="search"
              style={{padding: 0}}
              onClick={() => {
                if (isSearching === true) {
                  setRealSearch(search)
                } else {
                  setSearching(true)
                }
              }}
            >
              <SearchIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>

      <div className="ap-list__wrapper" style={{padding: '30px 8px'}}>
        {filteredOptions.map((o, i) => (
          <div
            key={i}
            className={`ap-list__item ap-typography ap-typography--sm ap-flex ap-flex--start ap-flex--align-center c-pop-field-toggle__option
              ${isSelected(o.field_id) ? 'selected_filter_field' : ''}`}
            style={{cursor: 'pointer'}}
            onClick={e => handleClickOption(e, o)}
          >
            {/* <Checkbox
                size="small"
                checkedIcon={<CheckCircleIcon style={{color: '#3473ff'}} />}
                checked={value.findIndex(v => v.field_id === o.field_id) !== -1}
              /> */}
            {o.field_name}
          </div>
        ))}
      </div>
    </div>
  )
}
